<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="pop-content-search">
                <el-form size="mini" label-width="65px">
                    <el-row :gutter="20">
                        <el-col :span="18">
                            <el-form-item label="엑셀파일">
                            <button type="button" class="btn-size btn-blue fl_left" @click="showEnableUploadArea">
                                <span class="btn-icon"><i class="fas fa-upload"></i></span>
                                신규 업로드
                            </button>
                            <!-- 신규업로드 -->
                            <div class="table-area mt20" v-if="enableUploadArea">
                                <div class="table-b">
                                    <div class="table-header">
                                        <div class="table-name">
                                            <h3 class="ico_table_name">업로드 파일 선택</h3>
                                        </div>
                                    </div>
                                    <div class="upload-area">
                                        <div class="input-area">
                                            <input type="text" class="input" v-model="file.name" readonly="readonly"/>
                                            <input ref="file" type="file" v-show="false" accept=".csv" @change="fileChangeEvent"/>
                                        </div>
                                        <div class="btn-wrap btn-type1">
                                            <button type="button" class="btn-size btn-gray fl_left" @click="searchFile">
                                                파일찾기
                                            </button>
                                            <button type="button" class="btn-size btn-blue fl_left" @click="uploadFile">
                                                업로드
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- //신규업로드 -->     
                            </el-form-item>
                        </el-col>
                         
                        <el-col :span="6">
                            <div class="btn-type1">
                                <el-button size="mini" type="primary" icon="el-icon-search" @click="save">
                                    저장
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                                
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        @rowDoubleClicked="rowDoubleClick"
                        @grid-ready="onGridReady"
                        />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
        tabData: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            title: '군공접수엑셀Upload',

            rowCount:0,
            enableUploadArea: false,
            file: {
                name: undefined
            },
            fileLoaded: false,

            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            
            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */
            setupGroupId: '',

            columnDefs:[
                {
                    headerName: '제조사', 
                    width:200,
                    field:'makerNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '제품군', 
                    width:200,
                    field:'modelGroupNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '대표모델', 
                    width:200,
                    field:'standardModelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '모델', 
                    width:400,
                    field:'modelNm', 
                    cellStyle:{textAlign:'center'}
                },                    
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            form: {}
        }
    },
    mounted() {
        // this.form = this.tabData[0] ? this.tabData[0].param : {}

    },
    methods: {
        showEnableUploadArea() {
            this.enableUploadArea = this.enableUploadArea ? false : true
        },
        searchFile() {
            this.$refs.file.click()
        },
        fileChangeEvent() {
            this.file = this.$refs.file.files[0] || {
                name: undefined
            }
            this.fileLoaded = this.$refs.file.files[0] !== undefined
        },
        uploadFile() {
            if (this.fileLoaded) {
                let form = new FormData();
                form.append('file', this.file);

                this.$store.commit('loading');
                this.$http.post('/api/asMng/armyCallList/upload', form, {timeout: 60000*60},{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$swal({
                        type: 'success',
                        text: response.data
                    }).then(this.query)

                    if(response.data === 0){
                        this.$swal({
                            type: 'error',
                            text: '업로드 / 저장에 실패되었습니다. 엑셀업로드 형식을 확인해주세요.'
                        });
                    } else {
                        this.$swal({
                            type: 'success',
                            text: '업로드에 성공했습니다.'
                        });

                        this.setupGroupId = response.data;
                        this.selectTmpArmyDataList(response.data);
                    }

                    return response;
                }).catch(response => {
                    this.$swal({
                        type: 'error',
                        text: response.data
                    });

                    this.setupGroupId = 0;
                    return response;

                }).finally(() => {
                    this.enableUploadArea = false;
                    this.$store.commit('finish');
                })
            } else {
                this.$swal({
                    type: 'warning',
                    text: '업로드할 파일을 선택해주세요.'
                })
            }
        },

        
        closeModal() {
            this.$parent.close();
        },
        onGridReady(){
            this.getCombo({flag: 'INIT'})
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 제조사
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
                    .then(response => {
                        this.makerList = response.data || []
                        this.makerList.unshift({key:'', value:'전체'})
                    });

                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/codeMng/combo`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupNmList = response.data || []
                        this.modelGroupNmList.unshift({key:'', value:'전체'})
                    });
                // 제품군 : ModelGroup, CAT_LVL(2)
                this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupList = response.data || []
                        this.modelGroupList.unshift({key:'', value:'전체'})
                        
                    });
            } else {
                if(param.parentId === ''){
                    this.subModelGroupShow =  false
                } else{
                    this.subModelGroupShow =  true

                    // 하위 제품군 : ModelGroup, CAT_LVL(2)
                    this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                        .then(response => {
                            this.subModelGroupList = response.data || []
                            this.subModelGroupList.unshift({key:'', value:'전체'})
                            this.subModelGroup = ''
                        });
                }
                
            } 
        },
        onModelGroupChange(e){
            // console.log('onModelGroupChange start====', e.target)
            // 모델이 변경시 하위 제품군 조회
            this.getCombo({flag: '', parentId: e.target.value})
        },
        selectTmpArmyDataList(vArmyGroupId){
            /** 업로드후 업로드된 데이타 조회 */
            const vform = {armyGroupId : vArmyGroupId}
            this.$store.commit('loading')
            this.$http.post(("/api/asMng/armyCallList/selectTmpArmyDataList"), vform
                ).then(response => {
                    console.log('addmodal response.data' , response.data)
                    this.rowData = response.data || []
                }).finally(() => {
                    this.$store.commit('finish')
                });
        }, 
        save(){

            if(this.setupGroupId === '' || this.setupGroupId === '0'){
                this.$swal({ type: 'warning', text: '업로드데이타가 없습니다. 신규업로드후에 저장하시기 바랍니다.' })
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `엑셀Upload를 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading')

                    const vform = {
                        setupGroupId: this.setupGroupId 
                    };
                    
                    this.$http.put(_url("/api/asMng/armyCallList/InsertArmyGroup"), vform)
                        .then(response => {
                             
                            this.$swal({ type: 'success', text: '저장되었습니다.' });
                            this.$emit('close', this.setupGroupId);
                            this.closeModal();

                        }).catch((e) => {
                            // console.error(e);
                            // this.$swal({ type: 'success', text: '저장에 실패 했습니다.' });
                        })
                        .finally(() => {
                            this.$store.commit('finish');
                        });

                }
            });
 
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>